import { atom } from 'recoil'
import { SavedTokens } from './types'

export const currentTokenState = atom<SavedTokens>({
  key: 'CurrentTokenState',
  default: { access: '', refresh: '' },
  effects: [
    ({ onSet, setSelf }) => {
      const savedValue = localStorage.getItem('tokens')
      if (savedValue != null) {
        const tokens: SavedTokens = JSON.parse(savedValue)
        setSelf(tokens)
      }

      onSet((newValue, _, isReset) =>
        isReset
          ? localStorage.removeItem('tokens')
          : localStorage.setItem('tokens', JSON.stringify(newValue))
      )
    },
  ],
})

export const otpSendState = atom({
  key: 'optSendState',
  default: { phone: -1, sent: false, otp: '' },
  effects: [
    ({ onSet }) => {
      onSet((value, _, isReset) => {
        if (isReset) {
          localStorage.removeItem('phone')
        } else {
          localStorage.setItem('phone', JSON.stringify(value.phone))
        }
      })
    },
  ],
})

export const refreshTokenCounter = atom<number>({
  key: 'RefreshTokenCounter',
  default: 0,
})
